module.exports = __webpack_public_path__ + "static/img/introduce_6.567ff1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/hlw/popup/introduce_6.png
// module id = agLc
// module chunks = 1